import React from "react";
import { Box, Grid } from "@mui/material";
import Typography from '@mui/material/Typography';
import Divider from '@mui/material/Divider';
import { useTranslation } from "react-i18next";
import { themes } from "theme/themes";
import { useSelector } from "react-redux";
import { brandingInfo } from "features/server/brandingSlice";
import { selectUserInfo } from "features/user/userSlice";

interface CardProps {
    data: unknown[];
    type: string;
    hasChild?: boolean;
    typeName?: string;
}

const Card: React.FC<CardProps> = ({data, type, hasChild, typeName}) => {
    const { t } = useTranslation();
    const loggedInUserCurrency = useSelector(selectUserInfo)?.business?.currency;
    const branding = useSelector(brandingInfo);
    const themeColors = branding?.attributes?.themeId === 100 ? branding?.attributes?.customTheme : (themes as any)[branding?.attributes?.themeId || 3];
    return (
        <Box>
            {data && data?.map((data: any) => (
                <Box className="mt-4">
                    <Grid container xs={12} 
                        sx={{ background: hasChild ? themeColors?.appBg : '#fff',
                            borderColor: type === 'item' ? themeColors?.primary : themeColors?.secondary
                        }}
                        style={type === 'package' ? { background: 'transparent', border: 'none', padding: 0 } : {}}
                        className={`items-center justify-between rounded-md border-l-2 p-2`}
                    >
                        <Grid xs={6} className="p-2 ">
                            <Typography className="font-Saira text-start line-clamp-1 font-[600] text-[14px] mb-2 leading-[17px]" >
                                {data?.title}
                            </Typography>
                            <Typography className="font-Saira text-start line-clamp-1 font-[400] text-[12px] leading-[15px]" >
                                <span>{t('code') + ': '}</span><span className="italic">{data[`${type}Code`]}</span>
                            </Typography>
                        </Grid>
                        <Grid xs={1} className="p-2 mx-2 font-Saira text-[11px]">
                            {typeName === 'invoice' ? (
                                <>
                                    <span className="font-bold text-[14px]">
                                        {data?.quantity || 0}
                                    </span>{" "}
                                    {t(type === 'package' ? t('packages') : type === 'service' ? t('services') : t(data?.unitTitle || 'unit(s)'))}
                                </>
                            ) : (
                                ''
                            )}
                        </Grid>
                        <Grid xs={3} className="p-2 flex ml-2 items-end justify-end ">
                            <Typography className="font-Saira text-start font-[700] text-[14px] leading-[20px]" >
                                {new Intl.NumberFormat("en-US",  loggedInUserCurrency ? {
                                    style: "currency",
                                    currency: loggedInUserCurrency || "",
                                }: {}).format(data?.unitPrice || data?.price || 0)}
                            </Typography>
                            <Typography className="font-[400] text-[11px] italic ml-1 mr-2">{t("each")}</Typography>
                            <Divider className="w-[2px]" sx={{ background: themeColors?.primary }} orientation="vertical" flexItem />
                            <Typography className="font-Saira text-start text-[#17ae36] font-[700] text-[14px] leading-[20px] ml-2" >
                                {new Intl.NumberFormat("en-US",  loggedInUserCurrency ? {
                                    style: "currency",
                                    currency: loggedInUserCurrency || "",
                                }: {}).format(data?.lineItemTotal || data?.subtotalAmount || 0)}
                            </Typography>
                            {/* <Typography className="font-[400] text-black text-[11px] ml-1 italic">SAR</Typography> */}
                        </Grid>
                        {data?.description ? <Grid xs={12} sx={{ borderTop: '1px solid #e5e5e5', paddingTop: '3px', margin: '3px 8px 0 8px' }}>
                            <Typography className="text-[11px] text-left font-Saira leading-2">
                                <span className="font-bold">{t('description') + ': '}</span>
                                {data.description}
                            </Typography>
                        </Grid> : ''}
                        {type === 'package' && data?.services?.length > 0 && 
                            <div className="w-[100%]"><Card data={data?.services} type="service" typeName={typeName || ''} /></div>
                        }
                        {type === 'package' && data?.items?.length > 0 && 
                            <div className="w-[100%]"><Card data={data?.items} type="item" typeName={typeName || ''} /></div>
                        }
                        {type === 'service' && data?.items?.length > 0 && 
                            <div className="w-[100%]"><Card data={data?.items} type="item" typeName={typeName || ''} hasChild={true} /></div>
                        }
                    </Grid>
                </Box>
            ))}
        </Box>
    );
};

export default Card;